import { render, staticRenderFns } from "./infosss.vue?vue&type=template&id=13578ec4&scoped=true&"
import script from "./infosss.vue?vue&type=script&lang=js&"
export * from "./infosss.vue?vue&type=script&lang=js&"
import style0 from "./infosss.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./infosss.vue?vue&type=style&index=1&id=13578ec4&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13578ec4",
  null
  
)

export default component.exports